import angular from 'angular';
import '../core.module';

export const COMPANY_BRANDING_CHANGED_EVENT = 'company:branding-changed';

class CompanyBrandingService {
  constructor($http, API_BASE_URL) {
    this.$http = $http;
    this.API_BASE_URL = API_BASE_URL;
  }

  get() {
    return this.$http
      .get(`${this.API_BASE_URL}/companies/me/branding`, { silentErrors: true })
      .then((response) => ({
        nome: response.data.name,
        logoFileId: response.data.logo_file_id || null
      }));
  }
}

CompanyBrandingService.$inject = ['$http', 'API_BASE_URL'];

angular.module('app.core').service('CompanyBrandingService', CompanyBrandingService);

export default CompanyBrandingService;
